import apiReq from 'core/api';

export interface ISettings {
  upload_max_size: {
    transcription: number | null;
    summarization: number | null;
    agreement_extraction: number | null;
    context_document_parsing: number | null;
  };
}

export const getSettings = async () => {
  const data = await apiReq<ISettings>('settings');
  if (!data) throw new Error('Empty response');
  return data;
};

// Бэкенд ожидает плоское тело с префиксом upload_max_size_*, тогда как GET
// возвращает вложенный объект upload_max_size. Разворачиваем при сохранении.
export const saveSettings = async (uploadMaxSize: ISettings['upload_max_size']) => {
  const body = {
    upload_max_size_transcription: uploadMaxSize.transcription,
    upload_max_size_summarization: uploadMaxSize.summarization,
    upload_max_size_agreement_extraction: uploadMaxSize.agreement_extraction,
    upload_max_size_context_document_parsing: uploadMaxSize.context_document_parsing,
  };
  return apiReq<ISettings>('settings', 'POST', body);
};
